export class AppError {
  constructor(public message: string) {}
}
